import { defineMessages } from 'react-intl';

import { CountryCode } from '@/shared/models/country-code';

import { ISupplementaryDocsGroup } from './types';

const INSURANCE_DOC_TYPES = {
  certificate: 'insurance_certificate',
  permissionLetter: 'policyholder_permission_letter',
  policySchedule: 'additional_doc1',
} as const;

const messages = defineMessages({
  title: {
    defaultMessage: 'Insurance',
    id: 'insurance_group_title',
    description: 'Insurance documents: group title in the docs list and dialog',
  },
  sectionTitle: {
    defaultMessage: 'About your policy',
    id: 'insurance_about_policy_title',
    description: 'Insurance documents: questions section title',
  },
  nameQuestion: {
    defaultMessage: 'Is your name on the insurance policy?',
    id: 'insurance_question_name_on_policy',
    description: 'Insurance documents: question',
  },
  nameHint: {
    defaultMessage:
      "Your name can appear either as the policyholder or in the list of persons entitled to drive. If you are not mentioned on the policy, you'll need a policyholder permission letter. <a>Learn more</a>",
    id: 'insurance_question_name_on_policy_hint',
    description: 'Insurance documents: question hint',
  },
  vehicleQuestion: {
    defaultMessage: "Is your vehicle's registration number listed on the insurance certificate?",
    id: 'insurance_question_vehicle_listed',
    description: 'Insurance documents: question',
  },
  vehicleHint: {
    defaultMessage:
      "If the certificate doesn't contain your vehicle, you'll need to upload a policy schedule showing your vehicle is covered. <a>Learn more</a>",
    id: 'insurance_question_vehicle_listed_hint',
    description: 'Insurance documents: question hint',
  },
  answerQuestionsHint: {
    defaultMessage: 'Answer both questions to continue.',
    id: 'insurance_save_hint_answer_questions',
    description: 'Insurance documents: hint next to the disabled save button',
  },
  uploadRemainingHint: {
    defaultMessage: 'Upload the remaining documents to continue.',
    id: 'insurance_save_hint_upload_remaining',
    description: 'Insurance documents: hint next to the disabled save button',
  },
});

const INSURANCE_GROUP: ISupplementaryDocsGroup = {
  countries: [CountryCode.GreatBritain],
  title: messages.title,
  sectionTitle: messages.sectionTitle,
  questions: [
    {
      docType: INSURANCE_DOC_TYPES.permissionLetter,
      ask: {
        storageKey: 'c_d_i_1',
        question: messages.nameQuestion,
        hint: messages.nameHint,
        uploadOn: 'no',
      },
    },
    {
      docType: INSURANCE_DOC_TYPES.policySchedule,
      ask: {
        storageKey: 'c_d_i_2',
        question: messages.vehicleQuestion,
        hint: messages.vehicleHint,
        uploadOn: 'no',
      },
    },
  ],
  learnMoreLink: 'faqUploadingInsurance',
  hints: {
    answerQuestions: messages.answerQuestionsHint,
    uploadRemaining: messages.uploadRemainingHint,
  },
};

export { INSURANCE_GROUP, INSURANCE_DOC_TYPES };
